import React from 'react'
import { connect } from 'react-redux';

import {
  getLoanDetailInterestType
} from 'containers/LoanApplication/reducers';

import RepaymentType from './select/RepaymentType';
import InterestPeriod from './select/InterestPeriod';

class Fixed extends React.Component {
  render() {
    const {
      interest,
      onChange,
    } = this.props;

    return(
      <div>
        <InterestPeriod
          title="Select the fixed interest period of your loan"
          checked={ interest.fixedInterestPeriod }
          onChange={ (value) => onChange({ fixedInterestPeriod: value }) }
        />
        <RepaymentType
          checked={ interest.fixedRepaymentType }
          onChange={ (value) => onChange({ fixedRepaymentType: value }) }
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  interest: getLoanDetailInterestType(state, 'fixed')
})

export default connect(mapStateToProps)(Fixed);
